import { ACCOUNT_MUTATION } from "@/apis/gql/apolloClient";
import type { AccountDetails } from "@/apis/gql/types";
import { useMutation } from "@apollo/client";
import { noop } from "lodash";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

type UpdateAccount = {
  accountId: string;
  accountName: string;
  accountNo: string;
  accountDescription: string | null;
};

export const useUpdateAccount = () => {
  const { t } = useTranslation();
  const [updateAccount, { data, loading, error }] =
    useMutation(ACCOUNT_MUTATION);

  const handleUpdateAccount = (
    data: UpdateAccount,
    onSuccess: (data: AccountDetails) => void = noop,
    onError: () => void = noop,
  ) => {
    const { accountId, ...updatedFields } = data;
    toast.promise(
      updateAccount({
        variables: {
          accountId,
          updatedFields,
        },
      }),
      {
        loading: t("generic_loading"),
        success: (updateAccountResult) => {
          onSuccess(updateAccountResult.data.updateAccount);
          return t("generic_success");
        },
        error: () => {
          onError();
          return t("generic_error");
        },
      },
    );
  };

  return [handleUpdateAccount, { data, loading, error }] as const;
};
